import { dispensaries,strains  } from "../data/data";
import React from 'react';
export function StrainDetailPage({ slug }) {
  const strain = strains.find((s) => s.slug === slug)

  if (!strain) {
    return <div>Strain not found</div>
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: '800',
          letterSpacing: '-0.025em',
          margin: 0
        }}>
          {strain.name}
        </h1>
        <button style={{
          padding: '8px 16px',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          backgroundColor: 'white',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          🔔 Track Price
        </button>
      </div>
      <p style={{ marginTop: '8px', fontSize: '18px', color: '#6b7280' }}>{strain.description}</p>
      <hr style={{ margin: '32px 0', border: 'none', borderTop: '1px solid #e5e7eb' }} />
      
      {strain.thc > 22 && (
        <div style={{
          marginBottom: '32px',
          border: '1px solid rgba(59, 130, 246, 0.5)',
          color: '#2563eb',
          padding: '16px',
          borderRadius: '8px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600', marginBottom: '8px' }}>
            ℹ️ Responsible Use
          </div>
          <p style={{ margin: 0 }}>This is a high-THC strain. If you're new, remember to start low and go slow.</p>
        </div>
      )}
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '32px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ position: 'relative', width: '100%', aspectRatio: '1' }}>
              <img 
                src={strain.image || "/placeholder.svg"} 
                alt={strain.name} 
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
              />
            </div>
          </div>
          
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontWeight: '600', margin: 0 }}>Key Info</h3>
            </div>
            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Type</span>
                <span style={{
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  backgroundColor: 
                    strain.type === "Sativa" ? '#2563eb' : 
                    strain.type === "Indica" ? '#dc2626' : 
                    '#6b7280',
                  color: 'white'
                }}>
                  {strain.type}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>THC</span> <strong>{strain.thc}%</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>CBD</span> <strong>{strain.cbd}%</strong>
              </div>
            </div>
          </div>
          
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontWeight: '600', margin: 0 }}>Reported Effects</h3>
            </div>
            <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {strain.effects.map((effect) => (
                <span key={effect} style={{
                  padding: '4px 8px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}>
                  {effect}
                </span>
              ))}
            </div>
          </div>
          
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontWeight: '600', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                🏷️ Flavor Profile
              </h3>
            </div>
            <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {strain.flavors.map((flavor) => (
                <span key={flavor} style={{
                  padding: '4px 8px',
                  backgroundColor: '#e5e7eb',
                  color: '#374151',
                  fontSize: '14px',
                  borderRadius: '4px'
                }}>
                  {flavor}
                </span>
              ))}
            </div>
          </div>
          
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontWeight: '600', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                🌱 Terpene Profile
              </h3>
            </div>
            <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {strain.terpenes.map((terpene) => (
                <span 
                  key={terpene.name} 
                  style={{
                    padding: '4px 8px',
                    backgroundColor: '#e5e7eb',
                    color: '#374151',
                    fontSize: '14px',
                    borderRadius: '4px',
                    cursor: 'help'
                  }}
                  title={terpene.description}
                >
                  {terpene.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb' }}>
              <h3 style={{ fontWeight: '600', margin: 0 }}>Where to Buy</h3>
            </div>
            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {strain.availability.map((d) => (
                <div key={d.id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px',
                  backgroundColor: 'rgba(0,0,0,0.05)',
                  borderRadius: '8px'
                }}>
                  <div>
                    <p style={{ fontWeight: '600', margin: 0 }}>{d.name}</p>
                    <p style={{
                      fontSize: '14px',
                      color: '#6b7280',
                      margin: 0,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}>
                      📍 {d.location}
                    </p>
                  </div>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    fontWeight: 'bold',
                    fontSize: '18px',
                    color: '#10b981'
                  }}>
                    💲 {d.price.toFixed(2)}
                    <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: 'normal' }}>/ 3.5g</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>Community Reviews</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              {strain.reviews.length > 0 ? (
                strain.reviews.map((review) => (
                  <div key={review.id} style={{ display: 'flex', gap: '16px' }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      overflow: 'hidden'
                    }}>
                      <img 
                        src={review.avatar || "/placeholder.svg"} 
                        alt={review.author}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                          <span style={{ fontWeight: '600' }}>{review.author}</span>
                          <span style={{
                            marginLeft: '8px',
                            padding: '2px 8px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '4px',
                            fontSize: '12px'
                          }}>
                            {review.tier}
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                          {[...Array(5)].map((_, i) => (
                            <span
                              key={i}
                              style={{
                                color: i < review.rating ? '#f59e0b' : '#6b7280',
                                fontSize: '16px'
                              }}
                            >
                              ⭐
                            </span>
                          ))}
                        </div>
                      </div>
                      <p style={{ marginTop: '8px', color: '#6b7280', margin: '8px 0 0 0' }}>{review.comment}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: '#6b7280' }}>No reviews yet. Be the first to share your experience!</p>
              )}

              <hr style={{ margin: '24px 0', border: 'none', borderTop: '1px solid #e5e7eb' }} />

              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>Leave a Review</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500' }}>Your Experience</label>
                  <textarea 
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '14px',
                      resize: 'vertical'
                    }}
                    rows="3" 
                    placeholder={`What did you think of ${strain.name}?`}
                  />
                  <button style={{
                    padding: '8px 16px',
                    backgroundColor: '#2563eb',
                    color: 'white',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    alignSelf: 'flex-start'
                  }}>
                    Submit Review
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}